import { AppThunk } from '../store/types';
import { fetchUserGroups } from '../../common/rest/userGroup/fetchUserGroups';
import { setUserAvailableGroups, setUserGroupsLoadedAction } from '../store/models/actions';
import { getUserGroups, isUserGroupsLoaded } from '../store/models/selectors';
import { appStore, getState } from '../store';

export const updateUserGroups = (enforceLoad: boolean): AppThunk => async (
  dispatch,
  getState
) => {
  let userGroups = getUserGroups(getState());
  if (!enforceLoad && userGroups && userGroups.length) {
    return userGroups;
  }
  const userGroupsPromise = (async () => {
    const userGroups = await fetchUserGroups();
    dispatch(setUserAvailableGroups(userGroups));
    dispatch(setUserGroupsLoadedAction(true));
    return userGroups;
  })();
  return userGroupsPromise;
}

export const awaitUpdateUserGroups = (
  timeoutMs = 10000
): Promise<boolean> => {
  if (isUserGroupsLoaded(getState())) {
    return Promise.resolve(true);
  }

  return new Promise<boolean>(resolve => {
    let unsubscribe: () => void = () => {};
    const timer = setTimeout(() => {
      unsubscribe();
      resolve(isUserGroupsLoaded(getState()));
    }, timeoutMs);

    unsubscribe = appStore.subscribe(() => {
      if (isUserGroupsLoaded(getState())) {
        clearTimeout(timer);
        unsubscribe();
        resolve(true);
      }
    });
  });
}
